import app from '../../scripts/app';
import template from './radio-wrapper.jade';
import './radio-wrapper.styl';

app.directive('cianAfRadioWrapper', [
  '$rootScope',
  () => ({
    scope: {},
    bindToController: {
      type: '@?',
      cuiRequired: '=',
      cuiChecked: '=',
    },
    controller() {},
    link: [
      '$scope',
      '$element',
      ($scope, $element) => {
        const ctrl = $scope.radioInvalid;
        const $input = $element.find('input');

        $input.bind('click', () => {
          $input[0].checked = !$input[0].checked;
          $scope.$apply();
        });

        ctrl.isChecked = () => {
          return $input[0].checked;
        };

        ctrl.typeIsInline = () => this.type === 'inline';
      },
    ],
    controllerAs: 'radioInvalid',
    transclude: true,
    replace: true,
    template,
  }),
]);
